import { Logo } from './logo'
import { NavLink, PremiumLink } from '@/components/analytics/tracked-link'

const productLinks = [
  { href: '/calculadoras', label: 'Calculadoras' },
  { href: '/comprovante-de-faturamento-mei', label: 'Comprovante de faturamento' },
  { href: '/quanto-posso-me-pagar-mei', label: 'Quanto posso me pagar' },
  { href: '/dre-simplificado-mei', label: 'DRE simplificado' },
  { href: '/atividades-mei', label: 'Profissões MEI' },
  { href: '/templates', label: 'Templates' },
  { href: '/blog', label: 'Blog' },
  { href: '/glossario', label: 'Glossário' },
  { href: '/premium', label: 'Premium' },
]

const supportLinks = [
  { href: '/faq', label: 'Dúvidas frequentes' },
  { href: '/contato', label: 'Contato' },
  { href: '/sobre', label: 'Sobre' },
]

const legalLinks = [
  { href: '/termos', label: 'Termos de uso' },
  { href: '/privacidade', label: 'Privacidade' },
  { href: '/cookies', label: 'Cookies' },
]

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer
      className="border-t border-border bg-card"
      role="contentinfo"
      aria-label="Rodapé"
    >
      <div className="container-app">
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 py-8 md:grid-cols-4 md:py-9">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="mt-4 max-w-xs text-[14px] text-foreground/75 leading-snug font-medium">
              Calculadoras grátis e sem cadastro para o MEI. O Premium cuida do mês a mês.
            </p>
          </div>

          <FooterColumn title="Produto" links={productLinks} />
          <FooterColumn title="Empresa" links={supportLinks} />
          <FooterColumn title="Legal" links={legalLinks} />
        </div>

        <div className="border-t border-border py-4 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <p className="text-[13px] text-foreground/70 font-medium">
            © {year} CalculaMEI
          </p>
          <p className="text-[13px] text-foreground/70 font-medium">
            Valores são referência. Confirme no Portal do Empreendedor.
          </p>
        </div>
      </div>
    </footer>
  )
}

function FooterColumn({
  title,
  links,
}: {
  title: string
  links: { href: string; label: string }[]
}) {
  return (
    <div>
      <h3 className="eyebrow mb-3">{title}</h3>
      <ul className="space-y-1.5">
        {links.map((link) => {
          if (link.href === '/premium') {
            return (
              <li key={link.href}>
                <PremiumLink
                  href={link.href}
                  local="footer"
                  className="text-[15px] font-semibold text-foreground/85 hover:text-[rgb(var(--green-deep))] transition-colors"
                >
                  {link.label}
                </PremiumLink>
              </li>
            )
          }
          return (
            <li key={link.href}>
              <NavLink
                href={link.href}
                secao="footer"
                rotulo={link.label}
                className="text-[15px] font-semibold text-foreground/85 hover:text-[rgb(var(--green-deep))] transition-colors"
              >
                {link.label}
              </NavLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
